<template>
  <main v-if="loaded">
    <div class="header-view">
      <div class="title">健康评估比对</div>
      <ul class="time">
        <li>
          <i>前</i>
          <span>{{first_report_tm}}</span>
        </li>
        <li>
          <i>后</i>
          <span>{{sec_report_tm}}</span>
        </li>
      </ul>
    </div>

    <!-- 提高项目对比图 -->
    <waterfall-card
        :class="['card-first', { more }]"
        v-if="list.length > 0"
        title="提高项目对比图"
        :list="list"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <!-- 有待提高项目比对图 -->
    <waterfall-card
        class="card"
        v-if="more && awaitList.length > 0"
        title="有待提高项目比对图"
        :list="awaitList"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <waterfall-card
        class="card-last"
        v-if="more && dynamics.length > 0"
        title="动态比对图"
        :list="dynamics"
        labelKey="item_dict_name"
        :valueKey="stackValueKey"
        :colorKey="stackColorKey"
        stack="diff"
        tips
        @tip="interpret = true"
    ></waterfall-card>

    <div
        v-if="!more"
        class="more-btn"
    >
      <div class="btn" @click="more = true">查看更多</div>
    </div>

    <!-- 比对数据报告表 -->
    <table-card class="table" title="比对数据报告表" :columns="columns" :list="tableList"></table-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import WaterfallCard from "@/components/WaterfallCard";
  import {reportCompareInfoH5} from "../net/api";
  import DialogView from "../components/DialogView";
  import TableCard from "../components/TableCard";

  export default {
    name: "Compare",
    components: {TableCard, DialogView, WaterfallCard},

    data() {
      return {
        // 当前数据是否加载完成
        loaded: false,

        packageNo: '',
        checkcode: '',
        rand: '',
        compare_id: '',

        more: false,

        // 通用态图列表数据关联项
        valueKey: {
          first_av: '前次检测',
          sec_av: '后次检测',
        },

        stackValueKey: [{
          first_one: '前次初值',
          first_two: '前次终值',
        }, {
          sec_one: '后次初值',
          sec_two: '后次终值',
        }],

        stackColorKey: ['first_color', 'sec_color'],

        // 提高项目对比图
        list: [],
        // 有待提高项目对比图
        awaitList: [],
        // 动态对比图
        dynamics: [],

        // 报告等级列表
        levels: [],
        // 解读说明弹窗
        interpret: false,

        columns: {
          item_dict_name: '检测项目',
          first_av: '前次检测',
          sec_av: '后次检测',
          av_difference: {
            name: '比对结果',
            value: (row) => {
              let val = row.av_difference;
              return val >= 0 ? '已提升' : '待提升';
            }
          }
        },

        tableList: [],

        // 报告检测时间
        first_report_tm: '',
        sec_report_tm: '',
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;
      this.compare_id = query.compare_id;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        reportCompareInfoH5({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          compare_id: this.compare_id
        }).then((data) => {
          this.levels = data.colorData || [];
          this.list = data.tableData.upItems;
          this.awaitList = data.tableData.downItems;
          this.dynamics = data.tableData.dongtaiItems;
          this.first_report_tm = data.first_report_tm;
          this.sec_report_tm = data.sec_report_tm;
          this.tableList = data.tableData.xiangxiItems;
          this.loaded = true;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-first {
    padding-bottom: 130px;

    &.more {
      padding-bottom: 20px;
      margin-bottom: 0;
      border-radius: 20px 20px 0 0;
    }
  }
  .card {
    border-radius: 0 0 0 0;
    padding-bottom: 20px;
    margin-bottom: 0;
  }
  .card-last {
    border-radius: 0 0 20px 20px;
  }

  .more-btn {
    position: absolute;
    width: 100%;
    left: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    .btn {
      position: absolute;
      top: -110px;
      width: 160px;
      height: 50px;
      background: #EDF4FF;
      border-radius: 25px;
      font-size: 24px;
      color: #6CA0EC;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .header-view {
    background: #FFFFFF;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 60px 30px;

    .title {
      display: flex;
      font-size: 50px;
      font-weight: 500;
      color: #333333;
      justify-content: center;
    }

    .time {
      margin-top: 50px;
      display: block;

      li {
        display: flex;
        align-items: center;
        margin-top: 10px;

        &:first-child {
          margin-top: 0;
        }

        i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: #2F95F6;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-size: 26px;
          font-weight: 600;
          color: #FFFFFF;
          border-radius: 50%;
        }

        span {
          margin-left: 30px;
          font-size: 30px;
          color: #333333;
        }
      }
    }
  }

</style>